import utilsComponent from 'utils/component';
import FanorakelView from 'views/FanorakelView';
import FanorakelVm from 'vms/FanorakelVm';
import BaseClass from 'application/BaseClass'

let fanorakelVm = FanorakelVm.create();

class FanorakelController extends BaseClass {
  constructor() {
    super();
    this.vm = fanorakelVm;
  }
}

let component = fanorakelVm.fanorakelId ? utilsComponent.make(FanorakelController, FanorakelView) : utilsComponent.empty;
export default component;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/fanorakelComponent.js